import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ProductPriceBlock, Tooltip } from '@codex/basics';
import { getTranslation } from '../../../translations/translations';

const StyledTooltip = styled(Tooltip)`
  width: 360px;
  height: auto;
  padding: 15px 0 15px 15px;
  ${(props) =>
    props.firstChild &&
    css`
      &:before {
        @media only screen and (max-width: 1359px) {
          left: 15%;
        }
      }
    `};
`;

const ProductTitle = styled.div`
  font-size: 12px;
  display: inline-block;
  text-decoration: none;
  padding-right: 10px;
  color: #4855a0;
`;

const ProductImg = styled.img`
  width: 80px;
  height: 70px;
  margin-top: 5px;
  margin-right: 15px;
  display: inline-block;
  vertical-align: top;
`;

const ProductInfo = styled.div`
  margin-top: 5px;
`;

const StyledProductPriceBlock = styled(ProductPriceBlock)`
  display: inline-block;
`;

const StyledAnchor = styled.a`
  color: #000;

  &:hover {
    color: #000;
  }
`;

export default function CompareProductTooltip(props) {
  const titleProduct = `${props.brand} ${props.title}`;
  return (
    <StyledTooltip arrow={'bottom'} type={'neutral'} firstChild={props.firstChild}>
      <StyledAnchor href={props.productUrl} onClick={props.onProductClick()}>
        <div>
          <ProductTitle href={props.productUrl}>{titleProduct}</ProductTitle>

          <ProductInfo>
            <ProductImg src={props.imageUrl} alt={props.imageAlt} />

            <StyledProductPriceBlock
              currentPrice={props.price.currentPrice}
              outOfStock={props.isProductOutOfStock}
              displayWasPriceRange
              savingsPrice={
                props.price.savingsPrice
                  ? `${getTranslation('savingsPriceTranslation')} ${props.price.savingsPrice}`
                  : undefined
              }
              wasPrice={
                props.price.wasPrice
                  ? `${getTranslation('wasPriceTranslation')} ${props.price.wasPrice}`
                  : undefined
              }
              wasPriceFrom={props.price.wasPriceFrom}
              wasPriceTo={props.price.wasPriceTo}
              variant={'compare_slider'}
              mainProductWasPriceTranslation={getTranslation('mainProductWasPriceTranslation')}
              webExclusivePriceTranslation={getTranslation('webExclusivePriceTranslation')}
              perMonthTranslation={getTranslation('perMonthTranslation')}
              fromDateTranslation={getTranslation('fromDateTranslation')}
              toDateTranslation={getTranslation('toDateTranslation')}
            />
          </ProductInfo>
        </div>
      </StyledAnchor>
    </StyledTooltip>
  );
}

CompareProductTooltip.disaplayName = 'ComparePanelProductTooltip';

CompareProductTooltip.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  productUrl: PropTypes.string,
  price: PropTypes.shape({
    currentPrice: PropTypes.string,
    savingsPrice: PropTypes.string,
    wasPrice: PropTypes.string,
    wasPriceFrom: PropTypes.string,
    wasPriceTo: PropTypes.string
  }).isRequired,
  isProductOutOfStock: PropTypes.bool.isRequired,
  imageAlt: PropTypes.string,
  brand: PropTypes.string,
  translations: PropTypes.shape({
    savingsPriceTranslation: PropTypes.string.isRequired,
    wasPriceTranslation: PropTypes.string.isRequired,
    fromDateTranslation: PropTypes.string.isRequired,
    toDateTranslation: PropTypes.string.isRequired
  }).isRequired,
  firstChild: PropTypes.bool,
  onProductClick: PropTypes.func
};

CompareProductTooltip.defaultProps = {
  productUrl: '#',
  imageAlt: '',
  brand: '',
  firstChild: false,
  onProductClick: () => {}
};
